import React, { useCallback, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { LoadingContext } from 'context/Loading';
import { ModalErrorContext } from 'context/ModalError';
import InvitationsServices from 'services/api/Invitations';
import handlePromise from 'utils/Promise';
import LinkValidateEmailView from './components/View';

function LinkValidateEmail() {
  const { uuid } = useParams();
  const navigate = useNavigate();
  const { toggleLoading } = useContext( LoadingContext );
  const { openErrorModal } = useContext( ModalErrorContext );

  const handleSubmitEmail = useCallback( async ( values: { email: string } ) => {
    toggleLoading( true );

    const [error, response, data] = await handlePromise(
      InvitationsServices.validateInvitationEmail( {
        linkUuid: uuid || '',
        email: values.email,
      } ),
    );

    if ( !response.ok ) {
      // Log technical error
      const errorMessage = error?.toString() || 'Ha ocurrido un error inesperado.';
      openErrorModal( errorMessage );
    } else if ( data ) {
      if ( data.invitationUuid ) {
        console.log( 'Access granted for UUID:', data.invitationUuid );
        navigate( `/link/informacion-confidencial/${data.invitationUuid}` );
      } else {
        console.warn( 'Validation failed: Link expired or email mismatch' );
        openErrorModal( 'El enlace ha expirado o la combinación de correo electrónico no es válida.' );
      }
    }

    toggleLoading( false );
  }, [uuid, openErrorModal, toggleLoading, navigate] );

  return (
    <LinkValidateEmailView
      onSubmit={handleSubmitEmail}
    />
  );
}

export default LinkValidateEmail;
